import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useRequest from "../../../utils/useRequest";
import PageWrapper from "../../../components/PageWrapper";
import Loader from "../../../components/Loader";
import axios from "axios";
import InternalPaperOrderList from "./InternalPaperOrderList";

export default function InternalPaperOrderPage() {
  // HOOKS
  const { id } = useParams();

  // STATES
  const [orderStatus, setOrderStatus] = useState("UNCOMPLETED"); // Default to UNCOMPLETED
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);

  // Add this function inside your component
  const fetchUnlinkedPaperList = async () => {
    if (!id) return;

    setLoading(true);
    setError(null);

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/paper/${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        const orderData = response.data;
        setData(orderData);
        setOrderStatus(() =>
          orderData?.isCompleted ? "COMPLETED" : "UNCOMPLETED"
        );
      }
    } catch (err) {
      setError(
        err.response?.data?.error || "Failed to fetch unlinked paper list"
      );
      console.error("Fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  // Call it in useEffect
  useEffect(() => {
    fetchUnlinkedPaperList();
  }, [id]);

  return (
    <PageWrapper withBackButton>
      <div className="u-margin--top_500 u-margin--bottom_500">
        {loading ? (
          <Loader />
        ) : (
          <InternalPaperOrderList
            data={data}
            setData={setData}
            orderStatus={orderStatus}
          />
        )}
      </div>
    </PageWrapper>
  );
}
